import { render } from "./CredentialFormModal.vue?vue&type=template&id=6fcca56b&scoped=true"
import script from "./CredentialFormModal.vue?vue&type=script&lang=js"
export * from "./CredentialFormModal.vue?vue&type=script&lang=js"

import "./CredentialFormModal.vue?vue&type=style&index=0&id=6fcca56b&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcca56b"]])

export default __exports__